"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FactBox_Collapse: "Collapse FactBox",
            FactBox_Open: "Open FactBox",
            FactBox_RegionTitle: "Related Information",
        },
    });
    $dyn.ax = $dyn.ax ? $dyn.ax : {};
    var controls;
    (function (controls) {
        /**
         * Framework base class for FactBox controls
         * @internal
         */
        var FactBox = /** @class */ (function (_super) {
            __extends(FactBox, _super);
            function FactBox(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // If this is the first factbox expand the factbox initially
                if ($(element).is(":first-child")) {
                    _this.IsFirstChild = true;
                }
                if (_this.IsFirstChild && _this.Root && $dyn.value(_this.Root.FactBoxPaneInitiallyExpanded) && $dyn.value(_this.Root.FactBoxPaneCollapsed)) {
                    _this.IsFirstChild = false;
                    _this.Root.ToggleFactBoxPane();
                }
                return _this;
            }
            /**
             * Returns if control is available for expando personalization feature
             * @returns true if available
             */
            FactBox.prototype.isControlAvailableForExpando = function () {
                return true;
            };
            /**
             * Returns Child form controls
             * @returns Array of child forms
             */
            FactBox.prototype.getChildForms = function () {
                var childrenInsideContainer = [];
                var formElements = $(this.element).find('[data-dyn-role="FactBoxForm"]');
                if (formElements && formElements.length > 0) {
                    childrenInsideContainer.push($dyn.context(formElements[0]));
                    if (formElements.length > 1) {
                        $dyn.logError("FactBox: More than one form found");
                    }
                }
                return childrenInsideContainer;
            };
            /**
             * @returns expando personalization focus element
             */
            FactBox.prototype.getExpandoPersonalizationFocusTarget = function () {
                return $(this.element).find(".section-page-header");
            };
            FactBox.prototype.toggleFactBoxExpanded = function () {
                // First save personalization then call expanded changed as persist personalzation will also save the original values for views
                $dyn.callFunction(this.PersistPersonalization, this, ["expanded", !$dyn.value(this.Expanded)]);
                this.Expanded(!$dyn.value(this.Expanded));
                if (this.Root) {
                    if ($dyn.value(this.Expanded)) {
                        var focusableControl = $dyn.util.findFirstFocusableControl(this.element);
                        // Set the forceFocus to true to make sure the FactBox header receives focus when needed
                        this.Root.InternalFocusIn(focusableControl, $dyn.context(this.Root.element).ActiveElement(), true);
                    }
                    else {
                        // Set the focus back to the Header
                        var focusableControl = $dyn.util.findFirstTabbableControl(this.element);
                        this.Root.form_setFocus(focusableControl, true);
                    }
                }
                if ($dyn.ax.personalizationUtil) {
                    $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                }
            };
            FactBox.prototype.expand = function () {
                if (!$dyn.value(this.Expanded)) {
                    this.toggleFactBoxExpanded();
                }
            };
            FactBox.prototype.collapse = function () {
                if ($dyn.value(this.Expanded)) {
                    this.toggleFactBoxExpanded();
                }
            };
            FactBox.prototype.keydown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            FactBox.prototype.canLoadForm = function () {
                // When the fact box is expanded for the first time (Expanded is true)
                // then the fact box form will load the contents of the fact box.
                var rootPaneCollapsed = this.Root ? $dyn.value(this.Root.FactBoxPaneCollapsed) : false;
                if ($dyn.value(this.IsFirstChild) === true) {
                    return $dyn.value(this.Visible) && !rootPaneCollapsed;
                }
                else {
                    return $dyn.value(this.Visible) && $dyn.value(this.Expanded) && !rootPaneCollapsed;
                }
            };
            return FactBox;
        }($dyn.controls.Part));
        controls.FactBox = FactBox;
        // tslint:disable:object-literal-sort-keys
        var FactBoxShortcuts = {
            ToggleExpand: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                Handler: function (evt) {
                    this.toggleFactBoxExpanded();
                },
                Description: function () {
                    return $dyn.value(this.Expanded) ? $dyn.label("FactBox_Collapse") : $dyn.label("FactBox_Open");
                },
            },
            Collapse: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.Number0 },
                Handler: function (evt) {
                    this.collapse();
                },
                Description: $dyn.label("FactBox_Collapse"),
            },
        };
        FactBox.prototype.Shortcuts = $dyn.extendPrototype(FactBox.prototype.Shortcuts, FactBoxShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FactBox.js.map
